import { Typography } from "@mui/material";
import { EllipsesStyle } from "../Types/IEllipsesStyle";
import { IKeyDriveFonts } from "../Types/IKeyDriveFonts";

export function KeyDriveh4Header({
    text,
    needEllipses,
    color,
    needBold,
    sxStyles
}: IKeyDriveFonts) {
    return (
        <Typography
            variant="h4"
            fontFamily="SEGOE UI"
            fontSize="20px"
            lineHeight="26px"
            fontWeight={needBold ? 600 : 400}            
            color={color}
            sx={needEllipses ? EllipsesStyle : sxStyles}
            textTransform="none"
        >
            { text }
        </Typography>
    )
}